export default "__VITE_ASSET__49c36734__"